module.exports = __webpack_public_path__ + "media/custom/images/img32-97748bf43ae61e400a70b459d8977e69.png";